import { render, staticRenderFns } from "./PeopleCards.vue?vue&type=template&id=c8a7f462&scoped=true&"
import script from "./PeopleCards.vue?vue&type=script&lang=js&"
export * from "./PeopleCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a7f462",
  null
  
)

export default component.exports